import { Component, Injector, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseView } from '../../../base-view';
import { FormFieldSettings } from '../data/form-field-settings';
import { FormFieldDataService } from '../form-field-data.service';

@Component({
  selector: 'app-dynamic-form-field',
  templateUrl: './dynamic-form-field.component.html',
  styleUrls: ['./dynamic-form-field.component.scss']
})
export class DynamicFormFieldComponent extends BaseView {

  @Input() id;
  @Input() type;
  @Input() hint;
  @Input() mode: 'standard' | 'grid' | 'card' | 'filter' = 'standard'
  @Input() label: string
  @Input() sectionLabel: string
  @Input() placeholder: string

  private _setDatasourceCompleted;

  /**
   * Deve essere propagato al formField
   */
  private _specifiedAttributes: any

  /** Questo è un setter non standard. Si tratta di un espediente per poter settare degli attributi di componente senza dover 
   * ricorrere ad un viewChild
   */
   @Input() set specifiedAttributes(keyValueSet: {[key: string]: any}){
    if(keyValueSet && keyValueSet.hasOwnProperty('setDatasourceCompleted')) {
      this._setDatasourceCompleted = keyValueSet.setDatasourceCompleted;

      if(([null,undefined].includes(this._value) || (this.value as any[]).length==0)){
        if(this._settings.occurrences && this._settings.occurrences.min && this._settings.occurrences.min>0){
          for (let index = 0; index < this._settings.occurrences.min; index++) {
            this.emitAdd()
          }
        }
        
        else if(this._settings.required == true)
          this.emitAdd()
      }
    }
    this._specifiedAttributes = keyValueSet;
  }
  get specifiedAttributes(){
    return this._specifiedAttributes;
  }

  /** 
   * questa variabile deve essere clonata a partire dai settings originali, 
   * il setting "required" (se presente) deve essere sostituito con il setting "notEmpty"
   */
  settingsWithRequiredAttributeReplacedByNotEmptyAttribute;

  private _settings: FormFieldSettings;
  @Input() set settings(settings: FormFieldSettings){
    if(settings) {
      this._settings=settings
      
      const clonedSettings  = {... settings}
      if(clonedSettings.required) {
        delete clonedSettings.required;
        clonedSettings.notEmpty = true;
      }
      this.settingsWithRequiredAttributeReplacedByNotEmptyAttribute = clonedSettings
    }
  }
  get settings(){
    return this._settings
  }

  private _value: number | string | boolean | (string|number)[]  | File | File[]
  @Input() set value(value: number | string | boolean | (string |number)[] | File | File[]){
    this._value = value;
  }
  get value(){
    return this._value;
  }

  public asArray = (value): any[] => value as any[]  //<= serve per castare ad array in un template (che non permette il casting)

  @Output() add: EventEmitter<any> = new EventEmitter<any>();
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();
  @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() clean: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(
    public formFieldDataService: FormFieldDataService,
    protected _injector: Injector) 
  { 
    super(_injector)
  }

  deleteClick(index){
    if(this._settings.occurrences && this._settings.occurrences.min && (this._value as any[]).length<=this._settings.occurrences.min)
      this.emitClean(index)
    else if((this._value as any[]).length==1 && this._settings.required == true)
      this.emitClean(index)
    else
      this.emitDelete(index)
  }

  emitAdd(){
    this.add.emit()
  }

  emitDelete(index){
    this.delete.emit({index: index})
  }

  emitModelChange(innerEvent, index){
    this.modelChange.emit({innerEvent: innerEvent, index: index})
  }

  emitClean(index){
    console.log('emitClean :>> ', index);
    this.clean.emit({index: index})
  }
}
